import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadPosOrders = async () => {
  try {
    const response = await Axios.get('pos-orders');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadPickLaterOrders = async () => {
  try {
    const response = await Axios.get('pos-orders/pick-later-orders');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadPosSessionOrders = async () => {
  try {
    const response = await Axios.get('pos-session');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadPosSessionOrder = async () => {
  try {
    const response = await Axios.get('pos-session/order');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadPosPaymentMethods = async (session_id) => {
  try {
    const response = await Axios.get('pos/payment-methods/'+session_id);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadSessionOrders = async (session_id) => {
  try {
    const response = await Axios.get('pos-orders/session/'+session_id);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOne = async (name) => {
  try {
    const respnse = await Axios.get('pos-orders/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadPosOrder = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/pos');
        const responseData = await response.data;
        return {...responseData, pos: {}};
        // return {taxes: [], products: [], contacts:[], operationTypes:[], quotation:{}};
        
      default:
        const data = await loadOne(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const usePosOrderAPI = () => {
  const { success, error } = useOutletContext();

  
  const create = async (data) => {
    try {
      const respnse = await Axios.post('pos-orders', data);
      const responseData = await respnse.data;
      success(responseData.message);
      return responseData.data;
      // EventEmitter.dispatch('posorder_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('pos-orders/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('posorder_response', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const createSessionOrder = async (data) => {
    try {
      const respnse = await Axios.post('pos-session', data);
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('posorder_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  }

  const updateSessionOrder = async (data) => {
    try {
      const respnse = await Axios.put('pos-session/update', data);
      const responseData = await respnse.data;
      return responseData;
      // success(responseData.message);
      // EventEmitter.dispatch('posorder_response', data.seo);
    }catch(err) {
      throw err;
    }
  }



  return { create, update, createSessionOrder, updateSessionOrder };
};



export default usePosOrderAPI;


